import locale from "@bonliva-crm/locale";
import { Tooltip, Typography } from "@material-ui/core";
import { GroupBase, ValueContainerProps, components } from "react-select5";

export function ValueContainerComponent<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: ValueContainerProps<Option, IsMulti, Group> & {
    maxValuesToDisplay?: {
      amount: number;
      valueToTooltipFn: (values: Option[]) => string;
    };
  }
) {
  const { maxValuesToDisplay, children, ...rest } = props;

  const renderChildren = () => {
    if (!maxValuesToDisplay || !Array.isArray(props.children)) return props.children;

    const childrenValues = props.children[0];

    if (!Array.isArray(childrenValues)) return props.children;

    const additionalChildren = childrenValues.slice(maxValuesToDisplay.amount);
    const values = props.selectProps.value;
    if (!Array.isArray(values)) return props.children;

    const tooltipTitle = maxValuesToDisplay.valueToTooltipFn(
      values.slice(maxValuesToDisplay.amount)
    );

    const additionalChildrenText =
      additionalChildren.length > 0 ? (
        <Tooltip title={tooltipTitle}>
          <div style={{ pointerEvents: "all" }}>
            <Typography variant="h5" style={{ fontWeight: 400 }}>
              {locale.SearchAnd.toLowerCase()} {additionalChildren.length}{" "}
              {locale.To.toLowerCase()}
            </Typography>
          </div>
        </Tooltip>
      ) : undefined;

    return [
      ...childrenValues.slice(0, maxValuesToDisplay.amount),
      additionalChildrenText,
      ...props.children.slice(1)
    ];
  };
  return (
    <components.ValueContainer {...rest}>{renderChildren()}</components.ValueContainer>
  );
}
